import React from 'react';
import { Crown } from 'lucide-react';
import SubscriptionPlans from '../SubscriptionPlans';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';

export const SubscriptionDialog = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="flex flex-col items-center gap-2 p-4 bg-slate-800/50 rounded-2xl hover:bg-slate-800 transition-colors border border-slate-700/50">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-yellow-600 flex items-center justify-center">
            <Crown className="h-5 w-5 text-white" />
          </div>
          <span className="text-sm text-white">Premium</span>
        </button>
      </DialogTrigger>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-md max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-amber-500 to-yellow-600 flex items-center justify-center">
              <Crown className="h-4 w-4 text-white" />
            </div>
            Premium Subscription
          </DialogTitle>
        </DialogHeader>
        <SubscriptionPlans />
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionDialog;
